import script from "./MetricsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricsChart.vue?vue&type=script&setup=true&lang=js"

import "./MetricsChart.vue?vue&type=style&index=0&id=0218606a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0218606a"]])

export default __exports__